import React from 'react'
import './portfolio.css'
import IMG1 from '../../assets/CRUD Assistant.jpg'
import IMG2 from '../../assets/load.jpg'
import IMG3 from '../../assets/load.jpg'
import IMG4 from '../../assets/load.jpg'
import IMG5 from '../../assets/load.jpg'
import IMG6 from '../../assets/load.jpg'

// DO NOT USE THR IMAGES IN PRODUCTION

const data = [
  {
    id: 1,
    image: IMG1,
    title: 'Product Management System ( CRUDS )',
    github: 'https://omarmushaeb.github.io/CRUD/crud.html',
  },
  {
    id: 2,
    image: IMG2,
    title: ' soon...',
    github: 'https://github.com/OmarMushaeb',
  },
  {
    id: 3,
    image: IMG3,
    title: 'soon...',
    github: 'https://github.com/OmarMushaeb',
  },
  {
    id: 4,
    image: IMG4,
    title: 'soon...',
    github: 'https://github.com/OmarMushaeb',
  },
  {
    id: 5,
    image: IMG5,
    title: 'soon...',
    github: 'https://github.com/OmarMushaeb',
  },
  {
    id: 6,
    image: IMG6,
    title: 'Charts templates & infographics in Figma',
    github: 'https://github.com/OmarMushaeb',
  }
]


const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {
          data.map(({id, image, title, github}) => {
            return (
              <article key={id} className='portfolio__item'>
              <div className="portfolio__item-image">
                  <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="portfolio__item-cta">
              <a href={github} className='btn' target='_blank'>Github</a>
              
              </div>
            </article>
            )
          })
        } 
      </div>
    </section>
  )
}

export default Portfolio
